import React, { useContext, useEffect, useState } from "react";
import Header from "./Comman/Header";
import { OnmaxContext } from "../OnmaxContext";
import axios from "axios";
import Pagination from "./Comman/Pagination";

export default function StakingIncome() {
  const { formatDateTime, formatAddress, copyaddress } = useContext(OnmaxContext);
  const [data, setdata] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const username = localStorage.getItem("username");


  const getData = React.useCallback(async () => {
    if (!username) {
      return;
    }
    setisLoading(true);

    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "weekreward",
        submethod: "getbyid",
        username: username,
        key: process.env.REACT_APP_KEY,
        page: currentPage,
        pageSize: pageSize,

      })
      .then((res) => {
        setisLoading(false);
        if (res.data.error) {
          return "";
        }
        setdata(res.data.data);
        setPages(Math.ceil(res.data.total / pageSize));

      });
  }, [username, currentPage, pageSize]);

  useEffect(() => {
    getData();
  }, [getData]);



  return (
    <>
      <div className="body-bg">
        <Header />
        <section className="nftmax-adashboard nftmax-show mt-4 setting-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">

                {/* Card Container */}
                <div className="db-profile-card mb-5">

                  {/* Card Header */}
                  <div className="db-sec-hdr">
                    <div className="db-sec-dot"></div>
                    <div className="db-sec-title">Weekly Reward</div>
                  </div>

                  <div className="card-body p-0 mt-3">
                    <div className="table-responsive">
                      <table className="table table-dashboard-premium align-middle mb-0" style={{ minWidth: '800px' }}>
                        <thead className="text-uppercase small">
                          <tr>
                            <th scope="col" className="ps-4 py-3" style={{ width: '10%' }}>Sr.</th>
                            <th scope="col" className="py-3" style={{ width: '20%' }}>Hash</th>
                            <th scope="col" className="py-3" style={{ width: '20%' }}>Invested Amount</th>
                            <th scope="col" className="py-3" style={{ width: '25%' }}>Reward Earned</th>
                            <th scope="col" className="pe-4 py-3 text-end" style={{ width: '25%' }}>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading && !data.length ? (
                            <tr>
                              <td colSpan="5" className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </td>
                            </tr>
                          ) : !data.length ? (
                            <tr>
                              <td colSpan="5" className="text-center py-5 text-slate-400">
                                <p className="mb-0">No data found</p>
                              </td>
                            </tr>
                          ) : (
                            data.map((ele, i) => {
                              const index = currentPage * pageSize - pageSize + (i + 1);
                              return (
                                <tr key={i} className="table-tr-premium">
                                  <td className="ps-4">
                                    <span className="text-slate-400 small">{index}</span>
                                  </td>

                                  <td>
                                    <span
                                      className="text-primary cursor-pointer small"
                                      onClick={() => copyaddress(ele.hash)}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      {ele.hash ? formatAddress(ele.hash) : '-'} <i className="fa fa-copy ms-1"></i>
                                    </span>
                                  </td>

                                  <td>
                                    <span className="fw-semibold text-white-custom">${ele.amount}</span>
                                  </td>

                                  <td>
                                    <div className="d-flex flex-column">
                                      <span className="fw-bold text-success">${ele.rewardamt ? ele.rewardamt.toFixed(2) : 0}</span>
                                      <span className="text-slate-400 text-xs text-nowrap">ROI: {ele.rewardper}%</span>
                                    </div>
                                  </td>

                                  <td className="pe-4 text-end">
                                    {ele.date ? (
                                      <span className="text-slate-400 small">{formatDateTime(ele.date)}</span>
                                    ) : '-'}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Card Footer for Pagination */}
                  <div className="card-footer bg-transparent border-top border-secondary border-opacity-10 p-4">
                    <Pagination
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      pages={pages}
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
